/* Bonify owns the product fields; native Modal/Tabs own focus and navigation. */
if (!customElements.get('lunya-size-guide-content')) {
  class LunyaSizeGuideContent extends HTMLElement {
    constructor() {
      super();
      this.onChange = this.update.bind(this);
    }

    connectedCallback() {
      this.addEventListener('change', this.onChange);
      this.update();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
    }

    update() {
      const fit = this.querySelector('[data-guide-fit]')?.value;
      if (fit) {
        this.querySelectorAll('[data-fit-description], [data-fit-measure]').forEach(node => {
          node.hidden = (node.dataset.fitDescription || node.dataset.fitMeasure) !== fit;
        });
      }
      const unit = this.querySelector('[data-guide-unit]:checked')?.value;
      if (unit) this.querySelectorAll('[data-guide-table]').forEach(node => { node.hidden = node.dataset.guideTable !== unit; });
    }
  }
  customElements.define('lunya-size-guide-content', LunyaSizeGuideContent);
}
